import { SET_SHOW_PREVIEW } from "../actions/ui";

const DEFAULT_STATE = {
    preview: true
};

export default function uiReducer(state, action) {
    if (!state) {
        state = {...DEFAULT_STATE};
    }

    switch (action.type) {
        case SET_SHOW_PREVIEW:
            state = {
                ...state,
                preview: action.showPreview
            }
            break
    }

    return state;
}